import { faGlobe } from '@fortawesome/pro-regular-svg-icons/faGlobe';
import { MprcText } from "components";
import { MprcNotice, MprcNoticeBlock } from 'components/MprcNotice';
import { TFunction } from 'i18next';
import TzUtils from 'lib/TzUtils';
import { useSession } from 'providers/SessionProvider';
import { useTranslation } from 'react-i18next';

export const LmsTimezoneNotice = ({ timezoneId }: { timezoneId: string; }) => {
    const { t } = useTranslation("lms");
    return TzUtils.browserTimezone() == timezoneId
        ? null
        : <MprcNotice size="small" items={[LmsTimezoneNoticeBlock(timezoneId, t)]} />;
};

export const LmsTimezoneNoticeBlock = (timezoneId: string, t: TFunction): MprcNoticeBlock => {
    const session = useSession();
    return {
        icon: faGlobe,
        text: <>{t("Components.LmsTimezoneNotice.Message")}: <MprcText color="warning"><b>{TzUtils.getTimezoneName(timezoneId, session.user.locale)}</b></MprcText></>
    };
};
